import React from 'react';
export function Logo() {
  return <div className="flex items-center gap-3" data-id="element-370">
      <div className="w-12 h-12" data-id="element-371">
        <svg viewBox="0 0 200 200" className="w-full h-full" data-id="element-372">
          <defs data-id="element-373">
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-374">
              <stop offset="0%" stopColor="#8B5CF6" data-id="element-375" />
              <stop offset="50%" stopColor="#06B6D4" data-id="element-376" />
              <stop offset="100%" stopColor="#10B981" data-id="element-377" />
            </linearGradient>
          </defs>
          {/* Zen circle */}
          <circle cx="100" cy="100" r="85" fill="none" stroke="url(#logoGradient)" strokeWidth="8" opacity="0.3" data-id="element-378" />
          {/* Incomplete circle (Zen symbol) */}
          <path d="M 100 15 A 85 85 0 1 1 99.9 15" fill="none" stroke="url(#logoGradient)" strokeWidth="10" strokeLinecap="round" opacity="0.9" data-id="element-379" />
          {/* Quest arrow/mountain */}
          <path d="M 100 60 L 70 120 L 100 105 L 130 120 Z" fill="url(#logoGradient)" opacity="0.9" data-id="element-380" />
        </svg>
      </div>
      <div data-id="element-381">
        <h1 className="text-2xl font-fredoka font-bold bg-gradient-to-r from-game-purple via-game-teal to-game-coral bg-clip-text text-transparent" data-id="element-382">
          QuestZen AI
        </h1>
        <p className="text-xs text-gray-500 dark:text-gray-400 font-quicksand" data-id="element-383">
          Turn goals into focused quests
        </p>
      </div>
    </div>;
}